import { booleanAttribute, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StepClickable } from './stepper-clickable.types';

@Component({
  selector: 'ssc-stepper-clickable',
  templateUrl: './stepper-clickable.component.html',
  styleUrl: './stepper-clickable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StepperClickableComponent {
  @Input({ transform: booleanAttribute }) public isClickable: boolean = true;
  @Input() public showDescription: boolean = true;
  @Input() public steps: StepClickable[];
}
